var map = {
	"./backtop/index.vue": "9GIZ",
	"./bread/wx_header.vue": "bzbx",
	"./footer/index.vue": "Bnh8",
	"./mark/index.vue": "2po0",
	"./our_server/article.vue": "RIPx",
	"./our_server/index.vue": "SmkK"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ZBoC";


//////////////////
// WEBPACK FOOTER
// ./src/components \.vue$
// module id = ZBoC
// module chunks = 52